
import { PilotLead } from '../types';
import { functions } from './firebase';
import { httpsCallable } from 'firebase/functions';
import { getLatestAttributionSnapshot } from './attribution';

export type LeadPayload = {
  name: string;
  email?: string;
  phone?: string;
  bookingTitle?: string;
  totalAmount?: number;
  friendCount?: number;
  source?: string;
  submissionId?: string;
};

/**
 * PRODUCTION READY: Invokes trusted callable Cloud Function with 8000ms bounded timeout.
 */
export const saveLeadToCloud = async (
  lead: LeadPayload
) => {
  const saveLeadFn = httpsCallable<
    LeadPayload,
    { success: boolean; leadId: string; timestamp: string; alreadySubmitted?: boolean }
  >(functions, 'savePartnerLead', { timeout: 8000 });

  try {
    const res = await saveLeadFn({
      name: lead.name,
      ...(lead.email ? { email: lead.email } : {}),
      ...(lead.phone ? { phone: lead.phone } : {}),
      ...(lead.bookingTitle ? { bookingTitle: lead.bookingTitle } : {}),
      ...(typeof lead.totalAmount === 'number' ? { totalAmount: lead.totalAmount } : {}),
      ...(typeof lead.friendCount === 'number' ? { friendCount: lead.friendCount } : {}),
      ...(lead.source ? { source: lead.source } : {}),
      ...(lead.submissionId ? { submissionId: lead.submissionId } : {}),
    });
    return res.data;
  } catch (error) {
    console.error("Cloud lead submission failed:", error);
    throw error;
  }
};

export interface AttributionEventPayload {
  visitorId: string;
  visitorToken: string;
  path: string;
  search: string;
  queryParams?: Record<string, string>;
  normalized?: Record<string, string>;
  referrer?: string;
  hostname?: string;
  userAgent?: string;
  eventAt?: string;
}

/**
 * Record attribution event via trusted, rate-limited Cloud Function.
 */
export const recordAttributionEventToCloud = async (
  payload: AttributionEventPayload
) => {
  const recordEventFn = httpsCallable<
    AttributionEventPayload,
    { success: boolean; eventId?: string }
  >(functions, 'recordAttributionEvent', { timeout: 8000 });

  try {
    const res = await recordEventFn(payload);
    return res.data;
  } catch (error) {
    // Non-blocking: attribution failure should never break user flows
    console.warn("Attribution event ingestion failed:", error);
    return { success: false };
  }
};

